import React, { useState } from "react";
import rewatch from "../../assets/rewatch.png";
import register from "../../assets/register.png";
import mindmapping from "../../assets/mind-mapping.png";
import mindmap from "../../assets/mind-map.png";
import mind from "../../assets/mind.png";
import meditation from "../../assets/meditation.png";
import report from "../../assets/report.png";

const data = [
  {
    id: "1",
    label: "ভিজিট + রেজিস্ট্রেশন",
    image:register,
  },
  {
    id: "2",
    label: "History Taking",
    image:rewatch,
  },
  {
    id: "3",
    label: "Thought ম্যাপিং টেস্ট",
    image:mindmapping,
  },
  {
    id: "4",
    label: "Mind ম্যাপিং টেস্ট",
    image:mind,
  },
  // {
  //   id: "5",
  //   label: "Knowledge ম্যাপিং টেস্ট",
  //   image:mindmap,
  // },
  {
    id: "6",
    label: "স্বাস্থ্যগত টেস্ট",
    image:meditation,
  },
  {
    id: "7",
    label: "Reports Card",
    image:report,
  },
];
const Program = () => {
  const [acitve, setActive] = useState("1");
  return (
    <div className="w-full bg-[#101E2B] flex justify-center items-center sm:py-[7rem] py-[4rem]">
      <div className="container flex flex-col items-center justify-center gap-4 px-4 sm:px-0">
        <h1 className="sm:text-4xl text-3xl font-bold text-white text-center ">
          রিভাইভ টেস্টে যা যা থাকছে
        </h1>
        <p className="text-white text-center text-xl">
          আপনার সন্তানকে (৭-১৬ বছর) REVIVE করতে আজই টেস্ট করুন-
        </p>

        <div className="mt-[4rem] w-full flex md:flex-row flex-col gap-8">
          <div className="md:w-1/4 w-full flex flex-col gap-4 md:order-1 order-2">
            {data.map((items, index) => (
              <div key={index} className={`p-4 bg-white rounded-md cursor-pointer flex gap-2 items-center relative ${
                  acitve === items.id && "border-2 border-[#22BEFF]"
                }`}
                onClick={() => setActive(items.id)}
              >
                <img src={items.image} alt={items.label} className="w-[2rem]" />
                <span>{items.label}</span>

                <div
                  className={`absolute top-6  left-full ml-[-6px] w-3 h-3 bg-white transform  rotate-45 border-r-2 border-t-2 border-[#22BEFF] ${
                    acitve === items.id ? "block" : "hidden"
                  }`}
                ></div>
              </div>
            ))}
          </div>
          <div className="md:w-3/4 w-full md:order-2 order-1">

            <iframe
              className="w-full  aspect-video rounded-md"
              src="https://www.youtube.com/embed/oOHy-q94j6Q"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Program;
